import React from "react";
import { createSearchParams, useNavigate } from "react-router-dom";
import { IPackage } from "../../types/global";

const LocalPkgCard = ({ data }: { data: IPackage }) => {
  let navigate = useNavigate();
  const handleRoute = (searchParam: {} | null) => {
    // setActivePage(`${route["nav-item"]}`)
    if (searchParam) {
      navigate({
        pathname: "/package-details",
        search: createSearchParams(searchParam).toString(),
      });
    } else {
      navigate({
        pathname: "/package-details",
      });
    }
  };

  return (
    <div>
      {/* img container  */}
      <div className="h-80 w-full">
        <img
          src={`${process.env.REACT_APP_API}/uploads/images/${data.package_img}`}
          alt=""
          srcSet=""
          className="h-full w-full object-cover rounded-lg cursor-pointer"
          onClick={() => handleRoute({ pkg: data.id })}
        />
      </div>
      <div className="mx-3 -mt-12 bg-white rounded-lg shadow-lg overflow-hidden relative ">
        <div className="text-center pt-5">
          <h1
            className="capitalize text-xl font-semibold line-clamp-1 px-1 cursor-pointer"
            onClick={() => handleRoute({ pkg: data.id })}
          >
            {data.translation[0].package_title}
          </h1>
          <p className="capitalize text-primary-base text-sm mt-2 font-medium">
            {data.day}D {data.night}N | Rs. {data.starting_price}
          </p>
          <button className="bg-primary-base text-center w-full text-white py-2 mt-5">
            View Details
          </button>
        </div>
      </div>
    </div>
  );
};

export default LocalPkgCard;
